import { Component, input } from '@angular/core';

export type TagSeverity = 'secondary' | 'info' | 'success' | 'warn' | 'danger' | 'contrast' | undefined;

@Component({
  selector: 'app-primeng-tag',
  templateUrl: './primeng-tag.component.html',
  styleUrls: ['./primeng-tag.component.scss'],
  standalone: false,
})
export class PrimengTagComponent {
  value = input<string>('');
  severity = input<TagSeverity>(undefined);
  rounded = input<boolean>(false);
  icon = input<string>('');
  styleClass = input<string>('');
}
